module.exports = "/components/components/unavailabilityPreviewComponent-de4250.html";